import React, { Component } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { connect } from 'react-redux'
import { IntlProvider } from 'react-intl'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import 'react-big-calendar/lib/less/styles.less'
import 'react-toggle-switch/dist/css/switch.min.css'
import 'rc-drawer/assets/index.css'
import 'bootstrap'
import 'styles/bootstrap.scss'
import 'styles/app.scss'
import 'styles/app-rtl.scss'
import AppLocale, { formats } from '../lngProvider'
import MainApp from 'app/index'
import SignIn from '../Linkgua/containers/SignIn'
import VerifyCode from '../Linkgua/containers/VerifyCode'
import SignUp from '../Linkgua/containers/SignUp'
import AuthFailure from '../Linkgua/containers/AuthFailure'
import { setInitUrl } from '../actions/Auth'
import asyncComponent from 'util/asyncComponent'
import { checkAuthentication, getLinkguaType, isSignUpComplete } from 'util/checkAuthentication'
import PreemptiveSessionRefresher from 'util/PreemptiveSessionRefresher'
import { ApolloProvider } from 'react-apollo'
import SignOut from '../Linkgua/containers/SignOut'
import { getConfiguredClient } from 'util/graphqlClient'
import debug from 'debug'
import StripeHandler from 'containers/StripeHandler'
import { MessageToaster } from '../Linkgua/components/Notifications'
import { prop, propOr, path } from 'ramda'

const appLog = debug('linkgua:app')

const RestrictedRoute = ({component: Component, auth, setInitUrl, ...rest}) =>
  <Route
    {...rest}
    render={props => {
      let next

      appLog('restricted route', location.pathname, auth)
      switch (true) {
        case !checkAuthentication(auth.authUser):
          appLog('auth failed, redirecting to sign-in')
          setInitUrl()
          next = <Redirect
            to={{
              pathname: '/signin',
              state: {from: props.location}
            }}
          />
          break
        case isSignUpComplete(auth):
          appLog('auth ok, profile is complete, redirecting to app')
          next = <Component {...props} />
          break
        default:
          appLog('auth ok, profile needs more info, redirecting to sign-up')
          next = <Redirect to={'/signup'}/>
          break
      }

      return next

    }}
  />

class App extends Component {

  componentWillMount () {
    this.graphqlClient = getConfiguredClient()
  }

  render () {
    const {location, authUser, signInPending, auth, initURL, setInitUrl, history, isDirectionRTL, profile} = this.props

    const isSignUp = /signup/.test(location.pathname)
    const isAuthenticationFailure = /authfailure/.test(location.pathname)

    if (auth.authenticationFailure && !isAuthenticationFailure) {
      return (<Redirect to='/authfailure' />)
    }

    if (location.pathname === '/') {
      if (!checkAuthentication(authUser)) {
        appLog('User not authenticated redirecting to `/signin`')
        return (<Redirect to={'/signin'}/>)
      } else if (initURL === '' || initURL === '/' || initURL === '/signin') {
        let defaultPath
        const linkguaType = getLinkguaType(auth)
        appLog('linkguaType', linkguaType)
        switch(linkguaType) {
          case 'customer':
            defaultPath = '/customer/dashboard'
            break
          case 'specialist':
            if(!isSignUpComplete(auth)) {
              defaultPath = '/signup/specialist'
            } else {
              defaultPath = '/specialist'
            }
            break
          default:
            if (signInPending) {
              appLog('App.render sign in pending => no render for me')
              return null
            } else {
              appLog('App.render no profile/-type for signed in user => sign up')
              return <Redirect to={'/signup'}/>
            }
        }
        return (<Redirect to={defaultPath}/>)
      } else {
        return (<Redirect to={initURL}/>)
      }
    }

    // for RTL Support
    if (isDirectionRTL) {
      document.body.classList.add('rtl')
    } else {
      document.body.classList.remove('rtl')
    }
    const currentAppLocale = propOr(AppLocale['en'], path(['settings','locale'],profile), AppLocale)

    return <ApolloProvider client={this.graphqlClient}>
      <IntlProvider
        locale={currentAppLocale.locale}
        messages={currentAppLocale.messages}
        formats={formats}
      >
        <div className={'app-main' + (isSignUp ? ' outside-app' : '')}>
          <PreemptiveSessionRefresher/>
          <ToastContainer/>
          <MessageToaster/>
          <Switch>
            <RestrictedRoute
              path={'(/customer|/specialist|/admin)'}
              auth={auth}
              component={MainApp}
              setInitUrl={() => setInitUrl(history.location.pathname)}
            />
            <Route path='/authfailure' component={AuthFailure}/>
            <Route path='/signin' component={SignIn}/>
            <Route path='/verifycode' component={VerifyCode}/>
            <Route path='/signout' component={SignOut}/>
            <Route path='/signup/:type(specialist|customer)?' component={SignUp}/>
            <Route path='/stripe-callback' component={StripeHandler}/>
            <Route
              component={asyncComponent(() => import('components/Error404'))}/>
          </Switch>
        </div>
      </IntlProvider>
    </ApolloProvider>
  }
}

const mapStateToProps = ({settings, auth}) => {
  const {isDirectionRTL} = settings
  const {authUser, initURL, signInPending, profile, userType } = auth
  return {isDirectionRTL, authUser, signInPending, initURL, auth, profile, userType}
}

export default connect(mapStateToProps, {setInitUrl})(App)



// WEBPACK FOOTER //
// ./containers/App.js